 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"NotFound":"NotFound","bulkDelete~bulkEdit~clients~createTemplate~editTemplate":"bulkDelete~bulkEdit~clients~createTemplate~editTemplate","bulkDelete~bulkEdit":"bulkDelete~bulkEdit","bulkDelete":"bulkDelete","bulkEdit":"bulkEdit","clients~createTemplate~editTemplate":"clients~createTemplate~editTemplate","clients":"clients","createTemplate":"createTemplate","editTemplate":"editTemplate","bulkSummary":"bulkSummary","bulkUpdate":"bulkUpdate","promoteReview":"promoteReview","promoteSummary":"promoteSummary","templates":"templates"}[chunkId]||chunkId) + "." + {"NotFound":"7926974e","bulkDelete~bulkEdit~clients~createTemplate~editTemplate":"7ae3ce09","bulkDelete~bulkEdit":"453dbd9f","bulkDelete":"e08e6ee0","bulkEdit":"3dc70fe2","clients~createTemplate~editTemplate":"30f64381","clients":"f0bf75e8","createTemplate":"6db693b0","editTemplate":"7a85aabd","bulkSummary":"8f1a6e0d","bulkUpdate":"7c5d657c","chunk-2d0c1b66":"2f352cbb","chunk-2d0d3267":"160f0ef9","chunk-2d0d622b":"f79403c5","chunk-2d0d83b7":"83fb915a","chunk-2d0db4e3":"f37e12b1","chunk-2d0e271e":"da08f9ca","chunk-2d0e5f6e":"6b241157","chunk-2d0e5f8c":"f77f9be8","chunk-2d2086f7":"5fa22359","chunk-2d208a9a":"2f40ba8a","chunk-2d20f539":"9aae474a","chunk-2d2106d8":"c4aa2d73","chunk-2d2167c7":"83a5908d","chunk-2d224d40":"699848b3","chunk-2d224ea4":"5d05bc78","chunk-2d22d9a9":"2ec50394","chunk-2d22fd52":"55d8c6fc","chunk-2d230f99":"f1a6c1e5","chunk-2d23862a":"e61cc287","chunk-eb8f479c":"748bc070","promoteReview":"e4400250","promoteSummary":"c82ed1a6","templates":"9676dfba"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"bulkDelete~bulkEdit~clients~createTemplate~editTemplate":1,"bulkDelete~bulkEdit":1,"bulkDelete":1,"bulkEdit":1,"clients~createTemplate~editTemplate":1,"clients":1,"createTemplate":1,"editTemplate":1,"bulkSummary":1,"bulkUpdate":1,"chunk-eb8f479c":1,"promoteReview":1,"promoteSummary":1,"templates":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"NotFound":"NotFound","bulkDelete~bulkEdit~clients~createTemplate~editTemplate":"bulkDelete~bulkEdit~clients~createTemplate~editTemplate","bulkDelete~bulkEdit":"bulkDelete~bulkEdit","bulkDelete":"bulkDelete","bulkEdit":"bulkEdit","clients~createTemplate~editTemplate":"clients~createTemplate~editTemplate","clients":"clients","createTemplate":"createTemplate","editTemplate":"editTemplate","bulkSummary":"bulkSummary","bulkUpdate":"bulkUpdate","promoteReview":"promoteReview","promoteSummary":"promoteSummary","templates":"templates"}[chunkId]||chunkId) + "." + {"NotFound":"31d6cfe0","bulkDelete~bulkEdit~clients~createTemplate~editTemplate":"50897842","bulkDelete~bulkEdit":"fa4c5bf9","bulkDelete":"0547f001","bulkEdit":"41ad0317","clients~createTemplate~editTemplate":"05f24790","clients":"3d26c5ec","createTemplate":"6cdf91c2","editTemplate":"6f3c41ab","bulkSummary":"46cc28d5","bulkUpdate":"1d59ccfc","chunk-2d0c1b66":"31d6cfe0","chunk-2d0d3267":"31d6cfe0","chunk-2d0d622b":"31d6cfe0","chunk-2d0d83b7":"31d6cfe0","chunk-2d0db4e3":"31d6cfe0","chunk-2d0e271e":"31d6cfe0","chunk-2d0e5f6e":"31d6cfe0","chunk-2d0e5f8c":"31d6cfe0","chunk-2d2086f7":"31d6cfe0","chunk-2d208a9a":"31d6cfe0","chunk-2d20f539":"31d6cfe0","chunk-2d2106d8":"31d6cfe0","chunk-2d2167c7":"31d6cfe0","chunk-2d224d40":"31d6cfe0","chunk-2d224ea4":"31d6cfe0","chunk-2d22d9a9":"31d6cfe0","chunk-2d22fd52":"31d6cfe0","chunk-2d230f99":"31d6cfe0","chunk-2d23862a":"31d6cfe0","chunk-eb8f479c":"cfdf3c42","promoteReview":"5acdd472","promoteSummary":"6b67208c","templates":"3a09c3e2"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
